import React from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import BackgroundImage from "gatsby-background-image"
import Image from "gatsby-image"
import { AccentBoxWhite } from "../AccentBoxes"
import Img from "gatsby-image"
import BlogCard from "../blog/BlogCard"
import ButtonLink from "../ButtonLink"

const newsArticles = [
  {
    content: `Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in print.`,
    link: `article1`,
  },
  {
    content: `Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in print.`,
    link: `article1`,
  },
  {
    content: `Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in print.`,
    link: `article1`,
  },
  {
    content: `Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in print.`,
    link: `article1`,
  },
  {
    content: `Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in print.`,
    link: `article1`,
  },
  {
    content: `Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in print.`,
    link: `article1`,
  },
  {
    content: `Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in print.`,
    link: `article1`,
  },
  {
    content: `Lorem ipsum, or lipsum as it is sometimes known, is dummy text used in print.`,
    link: `article1`,
  },
]

const LatestNews = ({ blogPosts }) => {
  const defaultData = useStaticQuery(graphql`
    query {
      defaultImage: file(relativePath: { eq: "Vanessa-Nature Picture.JPG" }) {
        childImageSharp {
          fluid(quality: 100, maxWidth: 2000) {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  const defaultImage = defaultData.defaultImage.childImageSharp.fluid

  return (
    <article className="grid">
      <div className="items-center index__row4 bg-white bg-opacity-75 flex flex-initial flex-col p-4 rounded shadow-md border border-gray-100">
        <div className=" relative bg-primary index__row4-title-container p-3 rounded shadow-md ">
          <h2 className="text-white p-4 text-4xl ">Latest News</h2>
          {/* <AccentBoxWhite className="-bottom-4 -left-4" borderColor="black" /> */}
        </div>
        {/* <span className="index__row4-accent-box1"></span>
        <span className="index__row4-accent-box2"></span> */}
        <div className="mt-12 pt-4 w-full">
          <ul className="grid gap-y-4 text-blue-light text-xl leading-snug list-none">
            {blogPosts.edges.map((blogPost, index) => {
              const { node } = blogPost

              {
                /* debugger */
              }
              return (
                <BlogCard
                  fluid={
                    node.featureImage.asset
                      ? node.featureImage.asset.fluid
                      : null
                  }
                  title={node.title}
                  text={node.summary}
                  handle={node.slug.current}
                  date={node._createdAt}
                  key={`${node.id}-${index}`}
                />
              )
              {
              }
            })}
          </ul>
        </div>

        <ButtonLink
          text="View all posts"
          handle="news"
          className="text-3xl mt-10"
        />
      </div>
    </article>
  )
}

export const query = graphql`
  fragment LatestNews on SanityBlogPost {
    id
    title
    summary
    _createdAt(formatString: "MMMM Do YYYY")
    slug {
      current
    }
    featureImage {
      asset {
        fluid(maxWidth: 500) {
          ...GatsbySanityImageFluid
        }
      }
    }
  }
`

export default LatestNews
